import React from 'react'
import PropTypes from 'prop-types'

import SearchV2 from 'components/SearchV2'
import FeatureSearchBatchImportFilters from 'components/deprecated/search/FeatureSearchBatchImportFilter'

import { FEATURE, VEHICLE_SUBTYPES } from 'utils/constants'

import useBatchImportSearchHook from './BatchImportSearch.hook'

const BatchImportSearch = ({ selected, onSelect }) => {
  const {
    columns,
    searchFilterModules,
    isSchoolBusFeature,
  } = useBatchImportSearchHook({
    selected,
    onSelect,
  })
  const searchMeta = isSchoolBusFeature
    ? { vehicleSubType: VEHICLE_SUBTYPES.BUS }
    : null
  return (
    <SearchV2
      className=""
      searchUri="features/search"
      resource={FEATURE}
      columns={columns}
      batchImport={true}
      SearchFilters={FeatureSearchBatchImportFilters}
      searchFilterModules={searchFilterModules}
      addToSearchRequestBody={searchMeta}
    />
  )
}

BatchImportSearch.propTypes = {
  selected: PropTypes.string,
  onSelect: PropTypes.func,
}

export default BatchImportSearch
